export const Endpoint = () => `/api/v3/useraction/organization_user_remove/`;
export const Csrf = () => `/api/v3/useraction/token/`;
export declare const QueryKey: never;
export type Payload = {
    emails: string[];
};
export type Response = void;
